import type { ReactNode } from "react";

import type { WPProductBanner } from "../../../../models/WPContentBlock";

export async function fetchProductBanner(
  model: WPProductBanner,
): Promise<ReactNode> {
  const { ProductBanner } = await import(
    "../../../components/blocks/ProductBanner/ProductBanner"
  );

  return <ProductBanner model={model} />;
}
